import { GenericActivityListPagination, GenericActivityListSort } from 'src/models/genericActivityList';
import { AbstractQuery } from 'src/models/query';

export class InboxQuery extends AbstractQuery {
	limit = 500;
	name = 'IFS_Desktop_Query_Queries_GetAllUnfinishedItemsForTheUserQuery';
	page = 1;
	sort: Array<GenericActivityListSort> = [
		{
			direction: 'DESC',
			property: 'timestamp',
		},
	];

	constructor(
		pagination: GenericActivityListPagination,
		sort: GenericActivityListSort,
		viewedUserId: null | number = null
	) {
		super();

		this.parameters = [{ statusRed: 'unseen' }, { statusYellow: 'seen' }];
		this.page = pagination.page;
		this.limit = pagination.rowsPerPage;
		this.sort = [sort];

		if (viewedUserId !== null) {
			this.parameters = [...this.parameters, { userId: viewedUserId }];
		}
	}

	uniqueQueryIdentifier(): string {
		return this.createStableIdentifier();
	}
}

export class GetAllDesktopAccessUsersForTheUserQuery extends AbstractQuery {
	name = 'IFS_Desktop_Query_Queries_GetAllDesktopAccessUsersForTheUserQuery';

	constructor() {
		super();

		this.page = 1;
		this.subscribeForUpdates = false;
	}
}
